import api from './api';

export const authService = {
  async login(credentials) {
    const response = await api.post('/auth/signin', credentials);
    const { access_token, refresh_token } = response.data.data;
    localStorage.setItem('token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    return response.data;
  },

  async validate() {
    const response = await api.post('/auth/validate');
    const user = response.data.data;
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  },

  async refresh() {
    const accessToken = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refresh_token');
    const response = await api.post('/auth/refresh', {
      access_token: accessToken,
      refresh_token: refreshToken,
    });
    const { access_token, refresh_token } = response.data.data;
    localStorage.setItem('token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    return response.data;
  },

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
  },

  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated() {
    return !!localStorage.getItem('token');
  },

  isAdmin() {
    const user = this.getUser();
    return user?.role === 'ADMIN';
  },
};
